import React, { useContext, useState, createContext } from "react";

export interface CartProperties {
  cart: any;
  setCart: React.Dispatch<React.SetStateAction<any>>;
  cartOpen: boolean;
  setCartOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const baseContext: CartProperties = {
  cart: null,
  setCart: () => {},
  cartOpen: false,
  setCartOpen: () => {},
};

const CartContext = createContext(baseContext);
export const CartContextProvider = ({
  cartData,
  children,
}: {
  cartData: any;
  children: React.ReactNode;
}) => {
  const [cart, setCart] = useState(cartData);
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <CartContext.Provider value={{ cart, setCart, cartOpen, setCartOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const { cart, setCart, cartOpen, setCartOpen } = useContext(CartContext);

  const addToCart = (
    variantId: string,
    quantity: number = 1,
    sellingPlanId: string | null = null
  ) => {
    const lines: {
      merchandiseId: string;
      quantity: number;
      sellingPlanId: string | null;
    }[] = [
      {
        merchandiseId: variantId.startsWith("gid:")
          ? variantId
          : `gid://shopify/ProductVariant/${variantId}`,
        quantity: quantity,
        sellingPlanId: sellingPlanId,
      },
    ];

    fetch("/api/cart/addToCart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cartId: cart.id || "",
        lines: lines,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setCart(data.cart);
        setCartOpen(true);
      });
  };

  const updateQuantity = (lineId: string, newQuantity: number) => {

    fetch("/api/cart/updateQuantity", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cartId: cart.id || "",
          lines: [{ id: lineId, quantity: newQuantity }],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setCart(data.cart);
    });
  };

  return { cart, setCart, cartOpen, setCartOpen, addToCart, updateQuantity };
};
